import React from "react";
import logoImage from "@iso/assets/images/logo.png";
import Image from "@iso/assets/images/rob.png";
import FourZeroFourStyleWrapper from "./404.styles";
import { Col, Divider, Row } from "antd";

export default function () {
  return (
    <FourZeroFourStyleWrapper className="iso404Page">
      {/* <div className="iso404Content">
        <h2>System Upgrading</h2>
        <h3>Please come back later</h3>
        <p>The page youre looking for doesnt exist or has been moved.</p>
      </div>

      <div className="iso404Artwork">
        <img alt="#" src={Image} />
      </div> */}
      <Row style={{ display: "contents" }}>
        <Col xs={20} sm={20} md={12} lg={12} xl={12}>
          <div
            className="iso404Content"
            style={{ display: "block", textAlign: "left" }}
          >
            {/* <h2>System Upgrade Notice</h2>
            <p>
              Dear players:
              <br />
              23 October 2024 (Singapore time, UTC+8), the system will under maintenance for upgrading works from
              11:00 am until 3:30 pm 23 October 2024. During this period, the system may be unavailable for login or some
              functions may be restricted after login. We apologize for any inconvenience this may cause.
              <br />
              <br />
              Thank you for your understanding.
              <br />
              <br />
              Marketing Department,
              <br />
              23 October 2024
            </p>
            <Divider />
            <h2>系统升级维护通知</h2>
            <p>
              各位玩家：
              <br />
              2024年10月23日 早上11:00时到2024年10月23日 下午03:30时 (新加坡时间UTC+8)，系统将进行升级维护。
              <br />
              <br />
              在此期间，系统可能无法登录或登录后部分功能受限。因此给您带来的不便，请多海涵！
              <br />
              <br />
              小时代市场部
              <br />
              2024年10月23日
            </p> */}
            <img
              alt="TMR World Trade Logo"
              style={{ margin: "auto" }}
              width={200}
              src={logoImage}
            />
            <h2>System Upgrade Notice</h2>
            <p>
              member.tmrworldtrade.com is currently undergoing a system upgrade.
            </p>
            <p>
              We are currently optimizing system performance and stability.
              Please try again later.
            </p>
            <p>For assistance, please contact your upline.</p>
            <Divider />
            <h2>系统升级维护通知</h2>
            <p>member.tmrworldtrade.com 正在进行系统升级。</p>
            <p>我们正在优化性能与稳定性，请稍后再访问。</p>
            <p>如需协助，请联系上线</p>
          </div>
        </Col>
      </Row>

      <div className="iso404Artwork">
        <img alt="#" src={Image} />
      </div>
    </FourZeroFourStyleWrapper>
  );
}
